import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { IBrand, IModel, Vehicle } from 'app/models/vehicle.model';
import { VehiclesService } from 'app/services/vehicle/vehicles.service';
import { CatalogService } from 'app/services/catalog/catalog.service';
import { User } from 'app/models/user.model';
declare const swal: any;

@Component({
  selector: 'app-edit',
  templateUrl: './edit.component.html',
  styleUrls: ['./edit.component.css']
})
export class EditComponent implements OnInit {

  vehicleForm: FormGroup;
  enterprise: User;
  years: number[];
  brands: IBrand[];
  models: IModel[];
  vehicle: Vehicle;
  id: number;
  // selectedBrand;
  brandControl;
  modelControl;

  constructor(public dialogRef: MatDialogRef<EditComponent>, 
    @Inject(MAT_DIALOG_DATA) public data: Vehicle,
    private formBuilder: FormBuilder,
    private vehicleService: VehiclesService,
    private catalogService: CatalogService) { 
      this.enterprise = JSON.parse(sessionStorage.getItem('loggedUser'));
      this.years = this.getYears();
      // 
      // this.getBrands();
      console.log(this.data.registerNumber)
      this.brandControl = new FormControl(this.data.model.brand, Validators.required);
      this.modelControl = new FormControl(this.data.model.id, Validators.required);
    
      this.vehicleForm = new FormGroup({
        capacity: new FormControl(this.data.capacity, Validators.required),
        year: new FormControl(this.data.year, Validators.required),
        registerNumber: new FormControl(this.data.registerNumber, Validators.required),
        model: this.modelControl,
        brand: this.brandControl
      })
    }

  async ngOnInit() {
    
    await this.getBrands();
    this.id = this.data.id
    if(this.data.id){
      this.brandControl = new FormControl(this.data.model.brand.id, Validators.required);
      this.getModels(this.data.model.brand.id);
      this.modelControl = new FormControl(this.data.model.id, Validators.required);
    }
  }

  onNoClick(): void {
    console.log('cerrando modal')
    this.dialogRef.close();
  }

  getYears(): number[]{
    let years: number[] = [];
    let actualYear = new Date().getFullYear();
    for (let index = 1995; index < actualYear + 1; index++){
      years.push(index)
    }
    years.reverse();
    return years
  }

  async getBrands(){
    this.brands = await this.catalogService.getBrands();
    // this.selectedBrand = this.brands[0].id;
  }

  getModels(id: any){
    console.log('brand id', id);
    console.log('brands', this.brands);
    this.models = this.brands.find(b => b.id == id).models;
    console.log(this.models);
  }

  loadData(){
    console.log(this.vehicleForm.status);
    if(this.vehicleForm.status === 'INVALID'){
      // DO NOTHING
      this.openAlert(0);
    }else{
      this.vehicle = this.vehicleForm.value;
      this.vehicle.id = this.id;
      this.vehicle.enterprise = this.enterprise.databaseId;
      console.log(this.vehicle);
      this.vehicleService.saveVehicle(this.vehicle).subscribe(vehicle => {
        console.log(vehicle);
        this.openAlert(1);
        this.dialogRef.close(vehicle);
      })  
    }
  }

  openAlert(type){
    switch (type) {
      case 1:
        swal({
          title: 'Guardado correctamente',
          text: 'Presiona OK para continuar',
          type: 'success',
          timer: 3000,
          showConfirmButton: false
        })
        break;
      case 0:
        swal({
          title: 'Atención',
          text: 'Debes llenar todos los campos requeridos',
          type: 'warning',
          confirmButtonClass: 'btn btn-danger'
        })
    }
  }
}
